import { BaseModel } from "./BaseModel";
import { CalcualtionResultKeys, ColumnHeaders, TabNames } from '../modules/Constants';

export class OtherCostModel extends BaseModel {
    constructor() {
        super();
        this.TabName = TabNames.OTHER_COST;
        this.TabIndex = 9;
        this.DataProcessor = new OtherCostProcessor();
    }


}

export class OtherCostProcessor {
    ExchangeRates;
    Years;
    Currency;
    Records;
    Headers;

    process(data) {
        this.ExchangeRates = [];
        this.Years = [];
        this.Records = [];
        this.Headers = [];
        this.Currency = data.currency;

        let study = data.study;
        let snapshots = data.snapshots;
        let version = data.version;


        study.exchangeRates.forEach(rate => {
            rate.Item2.Values.forEach(item => {
                this.ExchangeRates.push({
                    currency: rate.Item1,
                    year: new Date(item.Date).getUTCFullYear(),
                    value: item.Value
                });
            });
        });


        let firstSOPYear = Math.min.apply(Math, snapshots.map(snapshot => snapshot.SaleableParts?.map(part => new Date(part?.CustomerSOP?.Value.Fields[0]).getUTCFullYear())).reduce(function (a, b) { return a.concat(b) }, []));
        let firstYearSpend = firstSOPYear - (version?.SpendYearsPriorToSOP?.Value?.Fields[0] ?? 2);
        let lastYearSpend = firstSOPYear + (version?.SpendYearsAfterSOP?.Value?.Fields[0] ?? 0);
        snapshots.forEach(snapshot => {
            snapshot.SaleableParts.forEach(part => {
                let endDate = part.CustomerVolume?.Value?.Fields[0]?.EndDate;
                if (endDate) {
                    let year = new Date(endDate).getUTCFullYear();
                    if (year > lastYearSpend) {
                        lastYearSpend = year;
                    }
                }
            });
        })

        var yearsSpending = Array.from(Array((lastYearSpend - firstYearSpend) + 1), (_, x) => x + firstYearSpend);
        this.Years = yearsSpending;

        //JG - Update Years in case there are additional years outside of Spending Years.
        snapshots.forEach(snapshot => {
            let engineeringInvestments = snapshot?.EngineeringInvestment?.Value?.Fields?.[0]?.Fields?.[1] ?? []

            engineeringInvestments.forEach(item => {
                let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                volumes.forEach(volume => {
                    let year = new Date(volume.Date).getUTCFullYear();

                    if (this.Years.findIndex(x => x === year) <= -1) {
                        this.Years.push(year);
                    }
                });
            })

            snapshot.PlantInvestments?.forEach(plantInvestment => {
                //BuildingCapital
                plantInvestment.BuildingCapital.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });

                //QualityCapital
                plantInvestment.QualityCapital.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });

                //QualityExpense
                plantInvestment.QualityExpense.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });

                //QualityTooling
                plantInvestment.QualityTooling.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });

                //RearrangeCapital
                plantInvestment.RearrangeCapital.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });

                //RearrangeExpense
                plantInvestment.RearrangeExpense.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });

                //RearrangeTooling
                plantInvestment.RearrangeTooling.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });

                //StartupCosts
                plantInvestment.StartupCosts.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });

                //ValidationEquipment
                plantInvestment.ValidationEquipment.forEach(item => {
                    let volumes = item.Value.Fields[0].Cost.Value.Fields[0].Values

                    volumes.forEach(volume => {
                        let year = new Date(volume.Date).getUTCFullYear();

                        if (this.Years.findIndex(x => x === year) <= -1) {
                            this.Years.push(year);
                        }
                    });
                });
            });
        });

        this.Years.sort();

        snapshots.forEach(snapshot => {
            this.setRecords(snapshot);
        });

        this.configureHeader();
        let result = {
            headers: this.Headers,
            display: this.getDisplay(),
            numerics: this.getNumerics()
        };


        return result;
    }

    setRecords(snapshot) {
        let type = snapshot?.EngineeringInvestment.Value.Fields[0].Case;
        let engineeringInvestments = snapshot?.EngineeringInvestment?.Value?.Fields?.[0]?.Fields?.[1] ?? [];

        engineeringInvestments.forEach((investment, index) => {
            this.Records.push(new OtherCostRowModel(this.Years, snapshot, type, index, investment, null, this.ExchangeRates, this.Currency));
        })

        snapshot.PlantInvestments?.forEach(plantInvestment => {
            let plant = plantInvestment.Plant?.Value?.Fields[0]?.Number?.Fields[0];

            //BuildingCapital
            plantInvestment.BuildingCapital.forEach((buildingCapital, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.BUILDING_CAPITAL, index, buildingCapital, plant, this.ExchangeRates, this.Currency));
            });

            //QualityCapital
            plantInvestment.QualityCapital.forEach((qualityCapital, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.QUALITY_CAPITAL, index, qualityCapital, plant, this.ExchangeRates, this.Currency));
            });

            //QualityExpense
            plantInvestment.QualityExpense.forEach((qualityExpense, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.QUALITY_EXPENSE, index, qualityExpense, plant, this.ExchangeRates, this.Currency));
            });

            //QualityTooling
            plantInvestment.QualityTooling.forEach((qualityTooling, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.QUALITY_TOOLING, index, qualityTooling, plant, this.ExchangeRates, this.Currency));
            });

            //RearrangeCapital
            plantInvestment.RearrangeCapital.forEach((rearrangeCapital, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.REARRANGE_CAPITAL, index, rearrangeCapital, plant, this.ExchangeRates, this.Currency));
            });

            //RearrangeExpense
            plantInvestment.RearrangeExpense.forEach((rearrangeExpense, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.REARRANGE_EXPENSE, index, rearrangeExpense, plant, this.ExchangeRates, this.Currency));
            });

            //RearrangeTooling
            plantInvestment.RearrangeTooling.forEach((rearrangeTooling, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.REARRANGE_TOOLING, index, rearrangeTooling, plant, this.ExchangeRates, this.Currency));
            });

            //StartupCosts
            plantInvestment.StartupCosts.forEach((startupCosts, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.STARTUP_COSTS, index, startupCosts, plant, this.ExchangeRates, this.Currency));
            });

            //ValidationEquipment
            plantInvestment.ValidationEquipment.forEach((validationEquipment, index) => {
                this.Records.push(new OtherCostRowModel(this.Years, snapshot, CalcualtionResultKeys.VALIDATION_EQUIPMENT, index, validationEquipment, plant, this.ExchangeRates, this.Currency));
            });
        });
    }

    configureHeader() {
        let header = [
            ColumnHeaders.OPTION_NAME,
            ColumnHeaders.COST_TYPE,
            ColumnHeaders.PLANT_NUMBER,
            ColumnHeaders.SORT_ORDER,
            ColumnHeaders.OTHER_COST_DESCRIPTION
        ];

        this.Years.forEach(year => {
            header.push(year + " Amount");
        });

        header.push(
            ColumnHeaders.START_YEAR,
            ColumnHeaders.CURRENCY_PREFIX
        );

        this.Years.forEach(year => {
            header.push(`${year} Amount ${ColumnHeaders.CONVERTED_PREFIX}`);
        });

        header.push(
            ColumnHeaders.TOTAL_AMOUNT,
            ColumnHeaders.START_YEAR,
            `${ColumnHeaders.CURRENCY_PREFIX} ${ColumnHeaders.CONVERTED_PREFIX}`
        )

        this.Headers = header;
    }

    getDisplay() {
        let display = [];

        display.push(this.Headers);

        this.Records.forEach(record => {

            let row = [
                record.OptionName,
                record.CostType,
                record.PlantNumber,
                record.SortOrder,
                record.OtherCostDescription
            ]


            record.Cost.forEach(cost => {
                row.push(cost);
            });

            row.push(
                this.Years[0],
                record.Currency
            )

            record.CostConverted.forEach(cost => {
                row.push(cost);
            });

            row.push(
                record.CostConvertedTotal,
                this.Years[0],
                this.Currency
            )

            display.push(row);
        });

        return display;
    }


    getNumerics() {
        let numeric = [];

        //set number formatting
        let startCost = 5;
        let endCost = this.Years.length + startCost - 1;
        let startConvCost = endCost + 3;
        let endConvCost = this.Years.length + startConvCost;

        numeric.push({ start: startCost, end: endCost });
        numeric.push({ start: startConvCost, end: endConvCost });

        return numeric;
    }

}

export class OtherCostRowModel {
    OptionName = "";
    CostType = "";
    PlantNumber = "";
    SortOrder = "";
    OtherCostDescription = "";
    Cost = [];
    CostConverted = [];
    CostConvertedTotal = 0;
    Currency = "";

    constructor(years, snapshot, type, order, item, plant, exchangeRates, exchangeCurrency) {
        this.OptionName = snapshot.GroupName;
        this.CostType = type;
        this.PlantNumber = plant;
        this.SortOrder = order;
        this.OtherCostDescription = item?.Value?.Fields[0]?.Description?.Value?.Fields[0];
        this.Cost = [];
        this.CostConverted = [];
        this.CostConvertedTotal = 0;
        this.Currency = item?.Value?.Fields[0]?.Cost?.Value?.Fields[0]?.Tag;

        years.forEach(year => {
            let cost = undefined;
            let convCost = undefined

            if (item) {
                cost = item.Value.Fields[0].Cost.Value.Fields[0].Values.find(item => new Date(item.Date).getUTCFullYear() === year)?.Value ?? 0;

                let exchangeRate = exchangeRates?.find(rate => rate.year === year && rate.currency === exchangeCurrency);
                let currentCurrencyRate = exchangeRates?.find(rate => rate.year === year && rate.currency === this.Currency);

                if (exchangeRate === undefined || cost === undefined || currentCurrencyRate === undefined) {
                    if (cost !== undefined) {
                        this.CostConverted.push("Error");
                    } else {
                        this.CostConverted.push("");
                    }
                } else {
                    convCost = cost * exchangeRate.value / currentCurrencyRate.value;
                    this.CostConvertedTotal += convCost;
                }
            }

            this.Cost.push(cost);
            this.CostConverted.push(convCost);
        });
    }
}